import React from 'react';
import { Button, Form, Modal } from "react-bootstrap";

const APIWarningModal = props => {
    return (
        <Modal show={props.apiModalState !== ''} onHide={() => props.closeAPIModal()} backdrop="static" centered>
            <Modal.Header closeButton>
                {
                    props.apiModalState === 'disable' ?
                    <h4>Disable API Access</h4>
                    :
                    <h4>Generate New API Key</h4>
                }
            </Modal.Header>
            <Modal.Body>
                {
                    props.apiModalState === 'disable' ?
                    <p><strong>Warning:</strong> disabling API access will block any API requests and will reset an existing API key. Confirm to continue.</p>
                    :
                    <p><strong>Warning:</strong> generating a new API key will nullify your existing key. Confirm to continue.</p>
                }
            </Modal.Body>
            <Modal.Footer>
                <Button 
                    className="btn-brand-bg"
                    onClick={() => { 
                        if(props.apiModalState === 'disable'){
                            props.toggleAPIStatus(true);
                        }else{
                            props.updateAPIKey(true);
                        }
                    }}
                >
                    Confirm
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default APIWarningModal